import { useEventDetails } from '../../hooks/useEventDetails';
import { useAccount } from '../../hooks/useAccount';
import { useEventContext } from '../contexts/EventContext';
import { Navbar } from './Navbar';
import { NavbarV1 } from '../v1/components/NavbarV1';
import { formatEventDateTime } from '../../utils/formatEventDateTime';
import { formatEventDateTimeV2 } from '../../utils/formatEventDateTimeV2';

export const NavbarWrapper = () => {
  const { eventSlug, style: contextStyle } = useEventContext();
  const { data: eventDetails } = useEventDetails(eventSlug);
  const { data: accountData, isLoading: accountLoading } = useAccount();

  // Use style from context (passed from server) or from API response
  // Check if contextStyle has actual style data (not just an empty object)
  const eventStyle = (contextStyle && contextStyle.headerColor) ? contextStyle : eventDetails?.style;

  // Format the date for navbar display - simplified version
  const formatEventDate = () => {
    if (!eventDetails) return '';

    // Use appropriate formatter based on event version
    const formatter = eventDetails.isV1Event ? formatEventDateTime : formatEventDateTimeV2;

    // For navbar, always show just the date range without times, with full month names
    return formatter({
      startsAt: eventDetails.startsAt,
      endsAt: eventDetails.endsAt,
      showStartTime: false,
      showEndTime: false,
      timeZone: eventDetails.ianaTimeZone || eventDetails.timeZone,
      long: true
    });
  };

  // Use V1 navbar for V1 events
  if (eventDetails?.isV1Event) {
    return (
      <NavbarV1
        eventSlug={eventSlug}
        eventName={eventDetails?.name}
        eventDates={formatEventDate()}
        account={accountData || undefined}
        accountLoading={accountLoading}
        primaryColor={eventStyle?.headerColor}
        hasDays={eventDetails?.hasDays}
        hasContentPages={eventDetails?.hasContentPages}
        contentPages={eventDetails?.contentPages}
        contentPagesNavbarName={eventDetails?.contentPagesNavbarName}
        eventOptions={eventDetails?.eventOptions}
      />
    );
  }

  // V2 navbar
  return (
    <Navbar
      eventSlug={eventSlug}
      eventName={eventDetails?.name}
      eventDates={formatEventDate()}
      account={accountData || undefined}
      accountLoading={accountLoading}
      primaryColor={eventStyle?.headerColor}
      eventOptions={eventDetails?.eventOptions}
      registrationOpen={eventDetails?.registrationOpen}
      eventImageUrl={eventDetails?.imageUrl}
      hideEventDates={eventDetails?.eventOptions?.hideEventDates || false}
    />
  );
};